import i18n, { type BackendModule, type ResourceKey } from "i18next";
import { initReactI18next } from "react-i18next";

// Importar traduções de src (evita warning do Vite sobre assets em public).
// Só o pt-BR (padrão e fallback) vai no bundle inicial; o inglês é um chunk à
// parte, baixado quando for o idioma ativo ou quando a pessoa trocar.
import ptBR from "@/locales/pt-BR/translation.json";
import { resolverIdiomaInicial } from "@/lib/i18n-idioma";

const traducoesSobDemanda: BackendModule = {
  type: "backend",
  init() {},
  read(language, _namespace, callback) {
    if (language === "en") {
      import("@/locales/en/translation.json")
        .then((m) => callback(null, m.default as ResourceKey))
        .catch((error: Error) => callback(error, null));
      return;
    }
    if (language === "es") {
      import("@/locales/es/translation.json")
        .then((m) => callback(null, m.default as ResourceKey))
        .catch((error: Error) => callback(error, null));
      return;
    }
    callback(null, language === "pt-BR" ? (ptBR as ResourceKey) : {});
  },
};

export { I18N_LANGUAGE_KEY, I18N_LANGUAGE_EXPLICIT_KEY, salvarIdiomaEscolhido } from "@/lib/i18n-idioma";

// pt-BR por padrão; só usa outro idioma se a pessoa escolheu no seletor (ver i18n-idioma.ts).
const savedLanguage = resolverIdiomaInicial(typeof window !== "undefined" ? window.localStorage : null);

/** Resolve quando o idioma ativo está carregado; o main.tsx espera antes do 1º render. */
// `lang` do <html> acompanha o idioma (leitores de tela, tradução do navegador).
i18n.on("languageChanged", (lng) => {
  if (typeof document !== "undefined" && lng) document.documentElement.lang = lng;
});

export const i18nPronto = i18n
  .use(traducoesSobDemanda)
  .use(initReactI18next)
  .init({
    lng: savedLanguage,
    partialBundledLanguages: true,
    fallbackLng: "pt-BR",
    keySeparator: ".",
    nsSeparator: false,
    returnObjects: false,
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    resources: {
      "pt-BR": { translation: ptBR as Record<string, string | object> },
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;
